import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">My Pro Detailing · Excellence in Every Detail</p>
        <h1>Transform Your Vehicle Today</h1>
        <p className="lede">
          Experience the ultimate in vehicle care with My Pro Detailing. Our expert team is dedicated to restoring your vehicle's shine and protecting its value with top-notch detailing services.
        </p>
        <div className="cta-row">
          <a href="/services" target="_self">
            Explore Our Services
          </a>
          <a href="/contact" target="_self" className="secondary">
            Get in Touch
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Comprehensive Packages</h2>
          <p>
            Choose from a variety of detailing packages tailored to meet your vehicle's specific needs, ensuring a thorough clean inside and out.
          </p>
        </article>
        <article>
          <h2>Eco-Friendly Products</h2>
          <p>
            We use only the highest quality, eco-friendly products that are safe for your vehicle and the environment, giving you peace of mind with every service.
          </p>
        </article>
        <article>
          <h2>Expert Technicians</h2>
          <p>
            Our skilled technicians are passionate about cars and committed to delivering exceptional results, ensuring your vehicle looks its best.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;